import { Information } from '@carbon/icons-react'
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'

const DetailsPage = () => {
  return (
    <Box className='gap-3 w-[70%] max-w-[700px] flex flex-col m-auto border border-gray-200 p-6 bg-gray-50 rounded leading-relaxed'>
      <Text as='h3' fontSize='2xl' my={3} fontWeight='bold'>
        Data Sources and Limitations
      </Text>
      <Text mb={4}>
        Airfinity aggregates data from various external sources and are not a
        data generator. While we continuously review data to ensure accuracy and
        reliability, the quality of the data (such as its accuracy, completeness
        and granularity) is dependent on the original sources. Reporting
        frequency can be further subject to delays due to the time required for
        case detection, confirmatory testing, sequencing and sharing. All data
        are subject to change. Each of the countries included in this dashboard
        operates its own surveillance system with differing testing capacities
        and protocols. As such, indicators like test positivity and incidence
        rates are not necessarily directly comparable across countries. Testing
        policies can differ between pathogens and some countries may prioritise
        diagnostic testing for high-risk groups and hospitalised cases. Some
        countries may experience delays in uploading data, retrospective
        corrections, or temporary suspensions of reporting. These interruptions
        can introduce artificial dips or surges in trend lines that do not
        reflect real epidemiological changes. RSV and hMPV data may be less
        complete than influenza or COVID-19 due to historically lower
        prioritisation in surveillance systems. Serotype data is not split out
        (i.e. PIV3 data will be displayed as PIV). Test positivity can be a
        misleading indicator with a bias towards countries with superior testing
        capabilities and should be interpreted in the context of absolute
        testing numbers where available.
      </Text>
    </Box>
  )
}

const AboutDataPopover = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button
        minWidth={'150px'}
        maxW='150px'
        variant='clean'
        mr='auto'
        onClick={onOpen}
        fontSize='12px'
        alignItems={'center'}
      >
        <Box mr={1}>
          <Information />
        </Box>
        <Text
          variant='body'
          textDecor={'underline'}
          color='gray1'
          width='fit-content'
          whiteSpace={'break-spaces'}
          textAlign={'left'}
        >
          Data Sources and Limitations
        </Text>
      </Button>
      <Modal
        blockScrollOnMount={false}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent maxH='75vh' overflow='auto' width='100%' minW='1000px'>
          <ModalCloseButton />
          <ModalBody>
            <DetailsPage />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
export default AboutDataPopover
